import React from 'react';
import PropTypes from 'prop-types';

const NoSmoking = ({ color = '#224251', background = '#fff', ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" {...props}>
    <rect width={17.8} height={3.8} x={1.1} y={12.866} stroke="#224251" strokeWidth={0.8} rx={0.6} />
    <path stroke="#224251" strokeWidth={0.6} d="M5 13.266v3" />
    <path stroke="#224251" strokeLinecap="round" strokeWidth={0.7} d="M21 13.266v3M22.5 13.266v3" />
    <path
      stroke="#224251"
      strokeLinecap="round"
      strokeWidth={0.8}
      d="M20.79 5.266c-.97 0-2.426.467-2.426 1.4 0 .933.485.933 0 1.867-.485.933.65 1.733 1.136 1.733.485 0 .698-.578 1.29.133.473.57 0 1.867 0 1.867"
    />
    <path
      stroke="#224251"
      strokeLinecap="round"
      strokeWidth={0.8}
      d="M20 3.5c.636 0 2.093.24 2.5.766.407.526.573 1.014 0 2-.427.735-2 .581-2 1.5 0 .92 2.13.174 2.13.996v2.104"
    />
    <rect
      width={1.5}
      height={28.638}
      x={1.354}
      y={2.373}
      fill="#224251"
      stroke="#fff"
      strokeWidth={0.5}
      rx={0.75}
      transform="rotate(-45 1.354 2.373)"
    />
  </svg>
);

NoSmoking.propTypes = {
  color: PropTypes.string,
  background: PropTypes.string
};

export default NoSmoking;
